"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useStyle = ({ image }) => {
    const theme = (0, material_1.useTheme)();
    const cardItem = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '0px',
    };
    const imageBox = {
        width: '100%',
        height: '122px',
        borderRadius: '16px 16px 0px 0px;',
    };
    const contentBox = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '16px',
        gap: '16px',
        width: '100%',
        backgroundColor: theme.qlub.palette.iris_light.main,
        borderRadius: image ? '0px 0px 16px 16px' : '16px',
    };
    const descriptionStyles = {
        fontFamily: 'inherit',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '12px',
        lineHeight: '139.02%',
        display: 'flex',
        alignItems: 'center',
        letterSpacing: '0.004em',
        color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
    };
    return {
        cardItem,
        imageBox,
        contentBox,
        descriptionStyles,
    };
};
exports.default = useStyle;
